export default "__VITE_ASSET__efe3ae56__"